import { Link } from 'react-router-dom';
import VideoCard from '@/components/feature/VideoCard';
import { featuredVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑团队精心挑选的高品质内容</p>
          </div>
          <Link
            to="/category/documentary"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {featuredVideos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/documentary"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap"
          >
            查看全部精选
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}